<template>
  <div>

    <header id="header">
      <router-link class="logo" :to="{ name: 'Start'}">
        <img src="/projects/hetfruit/templates/customerportal/images/logo.png" height="60">
      </router-link>
      <h3>Kies je klant</h3>
    </header>

    <div class="start-buttons">
      <router-link class="btn start-btn" :to="{ name: 'CompanyOrders' }">Bedrijven bestellingen</router-link>
      <router-link class="btn start-btn" :to="{ name: 'DaycareOrders' }">Kinderdagverblijf bestellingen</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Start",
  components: {},
  data() {
    return {};
  },
  methods: {},
}

</script>

<style scoped>
.start-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 500px;
  margin: auto;
}

.start-btn {
  font-size: 20px;
  padding: 8px 20px;
  margin: 15px 0;
}
</style>
